module.exports = __webpack_public_path__ + "static/media/faboutImgCard3.25f8ebd0.png";